import type { Transaction } from "@/model/DataModel"
import { formatQuantity } from "@/utils/format"

export type ComparableTransactionSummary = {
	sourceInscriptionNumber?: string | null
	address?: string | null
	salePrice?: number | null
	registryDate?: string | null
}

export function summarizeComparableTransaction(transaction: Transaction): ComparableTransactionSummary {
	return {
		sourceInscriptionNumber: transaction.inscriptionNumber,
		address: transaction.location?.address,
		salePrice: transaction.deal?.salePrice,
		registryDate: transaction.deal?.registryDate?.toISOString(),
	}
}

export function formatComparableTransactionDetails(summary: ComparableTransactionSummary, locale: string): string[] {
	return [
		summary.salePrice != null ? `${formatQuantity(summary.salePrice)} $` : null,
		summary.registryDate
			? new Date(summary.registryDate).toLocaleDateString(locale === "en" ? "en-CA" : "fr-CA")
			: null,
	].filter((value): value is string => Boolean(value))
}
